export default function getCssVariable(
  name: string,
  element: HTMLElement,
  trimUnits: true
): number;
export default function getCssVariable(
  name: string,
  element: HTMLElement,
  trimUnits?: false
): string;
export default function getCssVariable(
  name: string,
  element: HTMLElement,
  trimUnits?: boolean
): string | number {
  const value = window.getComputedStyle(element).getPropertyValue(name).trim();
  return trimUnits ? Number.parseFloat(value) : value;
}
